import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import {
  ExportInterfaceConfigurationDetailsFilePlaceholderDTO,
} from 'src/app/base/models/models.swagger.generated';
import { ExportConfigurationService } from '../../../../../export-configuration.service';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationFormCoordinatorService } from '../../../configuration-form-coordinator.service';
import { RecordDoubleClickEventArgs } from '@syncfusion/ej2-grids';
import { ExportConfigurationMasterDataServiceService } from 'src/app/domain/export-configuration/export-configuration-master-data.service';
import { GridConstantsFactory } from '../../../../../../../base/shared/syncfusion/grid-constants-factory';
import { TranslateModule } from '@ngx-translate/core';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { GridModule } from '@syncfusion/ej2-angular-grids';

import { AppErrorMessagesComponent } from '../../../../../../../base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-configuration-form-file-name-placeholder',
    templateUrl: './configuration-form-file-name-placeholder.component.html',
    styleUrls: ['./configuration-form-file-name-placeholder.component.scss'],
    imports: [
    ReactiveFormsModule,
    AppErrorMessagesComponent,
    GridModule,
    QueryBuilderModule,
    TranslateModule
]
})
export class ConfigurationFormFileNamePlaceholderComponent implements OnInit {

  public filterSettings = GridConstantsFactory.createStandardFilterSettings();

  public get configurationFormFileName(): UntypedFormGroup {
    return this.configurationFormCoordinatorService.configurationFormFileName;
  }

  public get fileNameResult(): string {
    return this.configurationFormCoordinatorService.testFileName;
  }
  public data: ExportInterfaceConfigurationDetailsFilePlaceholderDTO[];

  constructor(private exportConfigurationService: ExportConfigurationService,
              private masterDataServiceService: ExportConfigurationMasterDataServiceService,
              public configurationFormCoordinatorService: ConfigurationFormCoordinatorService) {
  }

  ngOnInit() {
    this.masterDataServiceService.getMasterDataForFileName().subscribe(data => {
      this.data = data.possibleFileNamePlaceholders;
    });
  }

  public evaluateFileName() {
    const dto = this.configurationFormCoordinatorService.createConfigurationDetailsDTOFromForm();
    let observable: Observable<string>;
    if (this.configurationFormCoordinatorService.isTemplateMode) {
      observable = this.exportConfigurationService.getFilenameExampleFromStringTemplate(dto);
    } else {
      observable = this.exportConfigurationService.getFilenameExampleFromString(dto);
    }
    observable.subscribe(data => {
      this.configurationFormCoordinatorService.testFileName = data;
    });
  }

  public onCopyRecordValue(args: RecordDoubleClickEventArgs)  {
    const rowData = args?.rowData as ExportInterfaceConfigurationDetailsFilePlaceholderDTO;
    if (!rowData?.placeholder) {
      return;
    }
    let filename = this.configurationFormCoordinatorService.configurationFormFileName.get('fileName').value;
    this.configurationFormCoordinatorService.configurationFormFileName.get('fileName').setValue((filename ? filename : '') + rowData.placeholder);
  }
}
